/* unplugin-vue-components disabled */import { render } from "./LogoutCom.vue?vue&type=template&id=6a9d7092&scoped=true&lang=pug"
import script from "./LogoutCom.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutCom.vue?vue&type=script&setup=true&lang=js"

import "./LogoutCom.vue?vue&type=style&index=0&id=6a9d7092&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9d7092"]])

export default __exports__